<template>
    <div class="cashDetails">
        <Header msg='提现记录'/>

        <div class="cash-details" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" v-if="!shownull">
            <p class="detail-title"></p>
            <div class="detail-item" v-for="(e, i) in cashData" :key="i" :style="{'border-top':i === 0 ? 'none':'0.5px solid #eee'}">
                <div class="flex flex-j-c-sb flex-a-i-center">
                    <p style="font-size:0.16rem">{{e._formatDate}}</p>
                    <p class="detail-item-price">￥{{e.price}}</p>
                </div>
                <div class="detail-item-msg flex flex-j-c-sb flex-a-i-center">
                    <p>{{e._formatTime}}</p>
                    <p class="detail-item-status" :style="{color: e._strColor}">{{e.status}}</p>
                </div>
            </div>
            <Nomore v-if="showNoMore"/>
        </div>
        <DataNull v-if="shownull"/>

    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import DataNull from '@/components/DataNull';
import {GetCashList} from '@/api';
import Nomore from '@/components/Nomore';
import { Toast } from 'mint-ui';

export default {
    name: 'CashDetails',
    components: {
      Header,
      DataNull,
      Nomore
    },
    data() {
      return {
        page: 1, // 页数
        cashData: [], // 页面数据
        loading: true, 
        shownull: false,
        isShowMask: false, // x
        showNoMore: false
      }
    },
    watch:{
    },
    created() {
      this.getCashList(1);
    },
    
    methods: {
      // 加载更多
      loadMore(){
        if (this.loading) return false;
        this.loading = true
        this.page += 1;
        this.getCashList(2);
      },
      /**
       * 页面数据获取
       * type 1首次加载；2加载更多
       */
      getCashList(type) {
        GetCashList({page: this.page, limit: 10}).then(res => {
          if (res.code === 0) {
            if (type === 1) {
              this.cashData = res.data.list;
            } else {
              this.cashData = this.cashData.concat(res.data.list);
            }
            this.cashData.map(item => {
              if (!item._formatDate) {
                item._formatDate = item.addtime.slice(0,10);
                item._formatTime = item.addtime.slice(10,16);
                switch (item.status) {
                  case '待审核':
                    item._strColor = 'orange'
                    break;
                  case '已打款':
                    item._strColor = '#46d346'
                    break;
                  case '无效':
                    item._strColor = '#dd5252'
                    break;
                  default:
                    break;
                }
              }
            })
            if (res.data.list.length === 0) { this.shownull = true; };
            if (res.data.list.length === 10) { this.loading = false; };
            if (res.data.list.length !== 10 && res.data.list.length !== 0) { this.showNoMore = true };
            if (Number(res.data.row_count) === this.cashData.length) { this.loading = true;this.showNoMore = true };
          } else {
            this.shownull = true
          }
        })
      }
    }
}

</script>
<style lang='less' scoped>
.cash-details{
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: white;
    .detail-title{
    font-size: 0.16rem;
    font-weight: bold;
    width: 100%;
    height: 0.45rem;
    background: #eee;
    }
    .detail-item{
    padding: 0.1rem 0.2rem;
    border-top: 0.5px solid #eee;
    flex-direction: column;
    .detail-item-price{
        font-size: 0.2rem;
        color: #FABD01;
    }
    .detail-item-msg{
        margin-top: 0.1rem;
        p{
        color: #666;
        }
        p:last-child{
        color: #999;
        }
    }
    }
}
.detail-item-status{
    width: 30%;
    color: #666;
    text-align: right;
}
</style>